import { createTableColumn } from 'src/components/common/tableColumns/types';
import { UiTextTooltip } from 'src/components/UI/TextTooltip';

export const tableColumnEmail = createTableColumn<unknown>((title, { ...other } = {}) => ({
  title,
  sortPropertyName: 'Email',
  filter: {
    type: 'text',
    propertyName: 'Email',
  },
  className: 'text-left',
  renderValue: ({ Email }) => <UiTextTooltip>{Email}</UiTextTooltip>,
  ...other,
}));
